import React from 'react';
import Image from 'app/Components/Shared/Image/image';
const WarningMessage = ({message, children}) => {
  return (
    <div className='warning-component'>
      <div className='warning-component__content'>
        <img src={require('../images/alert-yellow.png')} alt='warning' />
        <span className='warning-component__warning-message' dangerouslySetInnerHTML={{__html: message}}></span>
      </div>
      {children}
    </div>
  );
};

export default WarningMessage;
